import { Checkbox } from "@/components/_atoms/checkbox";
import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";

import { type SelectedEntity, useCreateDataRequestStore } from "./create-data-request-state";

type EntityType = SelectedEntity["entityType"];

export function CheckboxCell({ entity, entityType }: { entity: SelectedEntity; entityType: EntityType }) {
  const { t } = useDomainTranslation("data-request");
  const selectedEntities = useCreateDataRequestStore((s) => s.selectedEntities);
  const toggleEntity = useCreateDataRequestStore((s) => s.toggleEntity);

  const isChecked = selectedEntities.some((e) => e.entityType === entityType && e.entityId === entity.entityId);

  return (
    <div className="flex items-center justify-center">
      <Checkbox
        checked={isChecked}
        onCheckedChange={() => toggleEntity(entity)}
        onClick={(e) => e.stopPropagation()}
        aria-label={t("createDialog.selectEntity", { entity: entity.entityTitle })}
      />
    </div>
  );
}
